import { forwardRef, type ThHTMLAttributes } from 'react';
import { cn } from '@helpers/cn';
import { Th } from './Table';

export const SortableTh = forwardRef<HTMLTableCellElement, ThHTMLAttributes<HTMLTableCellElement>>(
  ({ className, children, onClick, ...props }, ref) => (
    <Th ref={ref} className={cn('cursor-pointer select-none', className)} onClick={onClick} tabIndex={-1} {...props}>
      <button
        type="button"
        className="inline-flex min-h-11 items-center gap-1 text-left uppercase max-md:rounded-md max-md:border max-md:border-border max-md:bg-surface max-md:px-2 max-md:normal-case"
        onClick={(event) => {
          event.stopPropagation();
          event.currentTarget.closest('th')?.click();
        }}
      >
        {children}
      </button>
    </Th>
  ),
);
SortableTh.displayName = 'SortableTh';
